import React from 'react';
import { Form, Card, Button } from 'react-bootstrap';

const ReviewsEditor = ({ reviewsSection, onChange }) => {
  const handleChange = (field, value) => {
    onChange({ ...reviewsSection, [field]: value });
  };

  const handleReviewChange = (index, field, value) => {
    const newReviews = [...reviewsSection.reviews];
    newReviews[index] = { ...newReviews[index], [field]: value };
    onChange({ ...reviewsSection, reviews: newReviews });
  };

  const addReview = () => {
    onChange({
      ...reviewsSection,
      reviews: [...reviewsSection.reviews, { title: '', name: '', rating: 5, comment: '' }]
    });
  };

  const removeReview = (index) => {
    const newReviews = reviewsSection.reviews.filter((_, i) => i !== index);
    onChange({ ...reviewsSection, reviews: newReviews });
  };

  return (
    <Card className="mb-3">
      <Card.Header className='bg-neutral-gray'>
        <h5 className="mb-0">Reviews Section</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>Heading</Form.Label>
          <Form.Control
            type="text"
            value={reviewsSection.heading}
            onChange={(e) => handleChange('heading', e.target.value)}
          />
        </Form.Group>

        <div>
          <h6 className="mb-3">Reviews</h6>
          {reviewsSection.reviews.map((review, index) => (
            <div key={index} className="mb-3 p-3 border rounded">
              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-2">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={review.title}
                      onChange={(e) => handleReviewChange(index, 'title', e.target.value)}
                    />
                  </Form.Group>
                </div>

                <div className="col-md-6">
                  <Form.Group className="mb-2">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="text"
                      value={review.name}
                      onChange={(e) => handleReviewChange(index, 'name', e.target.value)}
                    />
                  </Form.Group>
                </div>

                <div className="col-md-12">
                  <Form.Group className="mb-2">
                    <Form.Label>Rating (1-5)</Form.Label>
                    <Form.Control
                      type="number"
                      min="1"
                      max="5"
                      value={review.rating}
                      onChange={(e) => handleReviewChange(index, 'rating', parseInt(e.target.value))}
                    />
                  </Form.Group>
                </div>

                <div className="col-md-12">
                  <Form.Group className="mb-2">
                    <Form.Label>Comment</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={2}
                      value={review.comment}
                      onChange={(e) => handleReviewChange(index, 'comment', e.target.value)}
                    />
                  </Form.Group>
                </div>
              </div>

              <Button variant="danger" size="sm" onClick={() => removeReview(index)}>
                <i className="fa fa-trash me-1"></i> Remove Review
              </Button>
            </div>
          ))}
          <Button variant="outline-primary" size="sm" onClick={addReview}>
            <i className="fa fa-plus me-1"></i> Add Review
          </Button>
        </div>
      </Card.Body>
    </Card>
  );
};

export default ReviewsEditor;
